import List from 'src/storage/list';
import moment from 'moment';
import constants from 'src/constants';
import AlertManager from 'src/components/alert';
import { lang, upperFirstCharAll, userFullName } from 'src/helpers';
import LANG_CONST from 'src/helpers/lang/const';

class AdminAppointmentModel extends List {
  id = 'AdminAppointmentModel';
  defaultState = () => ({
    sortBy: {
      sortKey: 'startDate',
      desc: true
    },
    current: 'recent',
    endDate: moment(),
    startDate: moment().add(-6, 'months'),
    total: 0,
    pageIndex: 0
  });
  refreshOnInit = false;
  refreshOnSubscribe = true;
  sortBy = null;

  apiConfig = {
    refresh: {
      url: 'admin/appointment/list',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true,
      event: 'admin_appointment_list'
    },
    list: {
      url: 'admin/appointment/list',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true,
      event: 'admin_appointment_list'
    },
    search: {
      url: 'admin/appointment/list',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true,
      event: 'admin_appointment_list'
    },
    updateStatus: {
      url: 'admin/appointment/update/status',
      validation: {
        id: 'string',
        value: 'string'
      },
      cancellable: true
    }
  };
  _events = {
    profile: 'handleChangeProfileAndSwitchAccount'
  };

  listParams() {
    let { pageIndex, startDate, endDate } = this.state;
    if (!startDate) startDate = 0;
    else startDate = parseInt(startDate.startOf('day').valueOf());
    if (!endDate) endDate = 0;
    else endDate = parseInt(endDate.endOf('day').valueOf());

    let req = {
      sortBy: this.state.sortBy,
      skip: pageIndex * this.listLimit,
      limit: this.listLimit,
      startDate,
      endDate
    };

    let query = this.listInput('search');
    if (query.length > 0) {
      req.query = query;
    }
    return req;
  }
  checkDisabledDoctor = (doctor) => {
    if (doctor.status === constants.general.userStatus.disabled) {
      if (doctor.id === model.state.user.id) model.emit('checkDisabledAccount', model.state.user);
      else
        AlertManager.popup(AlertManager.TYPES.INFO, {
          maxWidth: 450,
          close: false,
          title:
            doctor.role.includes('_') && doctor.clinicName
              ? lang.t(LANG_CONST.notice.disabled_clinic_doctor, {
                  clinic: upperFirstCharAll(doctor.clinicName),
                  doctor: upperFirstCharAll(userFullName(doctor))
                })
              : lang.t(LANG_CONST.notice.disabled_doctor, {
                  doctor: upperFirstCharAll(userFullName(doctor))
                }),

          actionButton: {
            label: LANG_CONST.buttons.ok,
            action: (props) => props.hide()
          }
        });
      return true;
    }

    return false;
  };

  showCancel = (item, cb) => {
    AlertManager.popup(AlertManager.TYPES.WARN, {
      title: LANG_CONST.notice.cancel_appointment,
      maxWidth: 520,
      cancelButton: {
        label: LANG_CONST.buttons.cancel,
        action: (actions) => actions.hide()
      },
      actionButton: {
        label: LANG_CONST.buttons.cancel_appointment,
        action: (actions) => {
          actions.setLoading(true);
          this.updateStatus(item, 'cancelled', (err, res) => {
            try {
              if (!err) {
                cb && cb(res);
                actions.hide();
                AlertManager.popup(AlertManager.TYPES.WARN, {
                  maxWidth: 400,
                  title: LANG_CONST.notice.cancelled_appointment,
                  close: false,
                  actionButton: {
                    label: LANG_CONST.buttons.ok,
                    action: (actions) => actions.hide()
                  }
                });
              }
            } catch (err) {
              console.log('ConfirmCancel hide err', err);
            }
            actions.setLoading(false);
          });
        }
      }
    });
  };
  updateStatus = (item, status, cb) => {
    const req = {
      id: item.id,
      doctorId: item.doctorId,
      value: status
    };
    let prevStatus = item.data.status || 'upcoming';
    item.data.status = status;
    this.setListStateSilent({ updated: Date.now() });
    this.api('updateStatus', req, (err, res, success) => {
      cb && cb(err, res, success);
      if (!success) {
        item.data.status = prevStatus;
        this.setListStateSilent({ updated: Date.now() });
      }
    });
  };
}

const model = new AdminAppointmentModel();
export default model;
